<template>
  <footer class="the-footer">
    <div class="the-footer__inner">
      <router-link to="/" class="the-footer__logo" aria-label="Prestige Inside — на главную">
        <img v-show="logoOk" src="/logo.png" alt="Prestige Inside" class="the-footer__logo-img" @load="logoOk = true" @error="logoOk = false" />
        <span v-show="!logoOk" class="the-footer__logo-text">PRESTIGE INSIDE</span>
      </router-link>
      <!-- <SocialIcons class="the-footer__social" /> -->
      <div class="the-footer__bottom">
        <p class="the-footer__copyright">© 2026 Prestige Inside</p>
        <button type="button" class="the-footer__terms" @click="openTerms">
          Пользовательское соглашение
        </button>
      </div>
    </div>
  </footer>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import SocialIcons from '@/components/SocialIcons.vue'

export default {
  name: 'TheFooter',
  components: { SocialIcons },
  setup() {
    const store = useStore()
    const logoOk = ref(true)

    function openTerms() {
      store.commit('setTermsModalOpen', true)
    }

    return { logoOk, openTerms }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

$ease: cubic-bezier(0.22, 1, 0.36, 1);

.the-footer {
  margin-top: auto;
  padding: 20px $gap 20px;
  background: $color-bg-alt;
  color: $color-primary-inverse;
  border-top: 1px solid rgba(255, 255, 255, 0.08);

  @media (max-width: $breakpoint-mobile) {
    padding: 20px $gap 20px;
  }
}

.the-footer__inner {
  max-width: $container-max;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 10px;
}

.the-footer__logo {
  display: block;
  line-height: 0;
  transition: opacity 0.25s $ease;

  &:hover {
    opacity: 0.9;
  }
  &:focus-visible {
    outline: 2px solid $color-accent-teal;
    outline-offset: 4px;
    border-radius: 6px;
  }
}

.the-footer__logo-img {
  display: block;
  height: 44px;
  width: auto;
  object-fit: contain;
}

.the-footer__logo-text {
  font-weight: 800;
  font-size: 15px;
  letter-spacing: 0.1em;
  color: $color-primary-inverse;
}

.the-footer__social {
  color: rgba(255, 255, 255, 0.88);
}

.the-footer__bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  max-width: 320px;
}

.the-footer__copyright {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.55);
  letter-spacing: 0.02em;
}

.the-footer__terms {
  margin: 0;
  padding: 0;
  font-size: 13px;
  font-family: inherit;
  color: $color-accent-teal;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
  transition: color 0.2s $ease, opacity 0.2s;

  &:hover {
    color: lighten($color-accent-teal, 14%);
  }
  &:focus-visible {
    outline: 2px solid $color-accent-teal;
    outline-offset: 2px;
    border-radius: 2px;
  }
}
</style>
